import type { SVGProps } from 'react';

const FileSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.25 0H1.5V12H10.5V5.25H5.25V0Z" fill="#616061" />
    <path d="M6.75 0V3.75H10.5L6.75 0Z" fill="#616061" />
  </svg>
);

export default FileSvg;
